import { FormItemsGroup, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { ContactEmail } from './elements/ContactEmail'
import { ContactFirstName } from './elements/ContactFirstName'
import { ContactLastName } from './elements/ContactLastName'
import { PrimaryContactCheckbox } from './elements/PrimaryContactCheckbox'

export const ContactPersonsModalBody = (): ReactElement => {
  return (
    <FormItemsGroup rowSpacing={Spacing.S12}>
      <FormItemsGroup itemsInRow={2}>
        <ContactFirstName />
        <ContactLastName />
      </FormItemsGroup>
      <ContactEmail />
      <PrimaryContactCheckbox />
    </FormItemsGroup>
  )
}
